/* ── Container ── */
.container {
  position: fixed;
  bottom: var(--space-4);
  right: var(--space-4);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 400px;
  pointer-events: none;
}

/* Mobile: bottom-center full-width */
@media (max-width: 767px) {
  .container {
    left: var(--space-4);
    right: var(--space-4);
    max-width: none;
  }
}

/* ── Toast item ── */
.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background-color: var(--color-bg-card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  border-left: 4px solid transparent;
  pointer-events: auto;
  min-height: 44px;
}

/* ── Type colors (left border) ── */
.success {
  border-left-color: var(--color-success-dark);
}

.error {
  border-left-color: var(--color-error);
}

.warning {
  border-left-color: var(--color-warning);
}

.info {
  border-left-color: var(--color-primary);
}

/* ── Icon ── */
.icon {
  flex-shrink: 0;
  width: 20px;
  text-align: center;
  font-size: var(--font-size-base);
  line-height: var(--line-height-normal);
}

.success .icon {
  color: var(--color-success-dark);
}

.error .icon {
  color: var(--color-error);
}

.warning .icon {
  color: var(--color-warning);
}

.info .icon {
  color: var(--color-primary);
}

/* ── Message ── */
.message {
  flex: 1;
  font-size: var(--font-size-sm);
  color: var(--color-text);
  line-height: var(--line-height-normal);
}

/* ── Close ── */
.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.close:hover {
  background-color: var(--color-bg-secondary);
}

.close:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
}

/* ── Animations ── */
.enter {
  animation: slideIn 0.2s ease forwards;
}

.exit {
  animation: slideOut 0.2s ease forwards;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(8px);
  }
}
